import React from 'react';
import { I18n } from '@aws-amplify/core';

import { Text } from '@/components/Typography';
import { CUSTOM_REPORT_RISKS } from '@/utils/enum';
import { riskColors, riskLevels } from '@/utils/riskRange';

import * as S from './styles';

export interface RiskTagProps {
	risk?: number;
}

export function RiskTag({ risk }: Readonly<RiskTagProps>): JSX.Element {
	if (!risk) {
		return <>{I18n.get('Not assigned')}</>;
	}

	const isSerious = risk === CUSTOM_REPORT_RISKS.SERIOUS_IMMINENT;

	const label = isSerious ? 'Serious risk' : riskLevels[risk];

	return (
		<S.TagRisk $riskLevel={risk} color={riskColors[risk]}>
			<Text ellipsis>{I18n.get(label)}</Text>
		</S.TagRisk>
	);
}
